import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
	faTelegram,
	faGithub,
	faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import INFO from "../data/user";
import { useLanguage } from "../i18n/LanguageContext";

import "./styles/contact.css";

const handleFromUrl = (url) => "@" + url.replace(/\/+$/, "").split("/").pop();

const Contact = () => {
	const { t, messages } = useLanguage();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const seo = messages.seo.contact;
	const contact = messages.contact;

	const channels = [
		{
			key: "telegram",
			icon: faTelegram,
			title: "Telegram",
			handle: handleFromUrl(INFO.socials.telegram),
			href: INFO.socials.telegram,
			primary: true,
		},
		{
			key: "email",
			icon: faEnvelope,
			title: "Email",
			handle: INFO.main.email,
			href: `mailto:${INFO.main.email}`,
		},
		{
			key: "instagram",
			icon: faInstagram,
			title: "Instagram",
			handle: handleFromUrl(INFO.socials.instagram),
			href: INFO.socials.instagram,
		},
		{
			key: "github",
			icon: faGithub,
			title: "GitHub",
			handle: handleFromUrl(INFO.socials.github),
			href: INFO.socials.github,
		},
	];

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${t("titles.contact")} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={seo.description} />
				<meta name="keywords" content={seo.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-container">
						<div className="contact-status">
							<span className="contact-status-dot" />
							{contact.available}
						</div>

						<div className="title contact-title">
							{contact.pageTitle}
						</div>

						<p className="contact-lead">{contact.lead}</p>

						<div className="contact-grid">
							{channels.map((c) => (
								<a
									key={c.key}
									className={`contact-card${
										c.primary ? " contact-card--primary" : ""
									}`}
									href={c.href}
									target="_blank"
									rel="noreferrer"
								>
									<div className="contact-card-icon">
										<FontAwesomeIcon icon={c.icon} />
									</div>
									<div className="contact-card-body">
										<div className="contact-card-title">
											{c.title}
										</div>
										<div className="contact-card-handle">
											{c.handle}
										</div>
										<div className="contact-card-hint">
											{contact.cards[c.key]}
										</div>
									</div>
									<div className="contact-card-cta">
										<span>{contact.write}</span>
										<FontAwesomeIcon icon={faArrowRight} />
									</div>
								</a>
							))}
						</div>

						<div className="contact-closing">
							<div className="contact-closing-text">
								{contact.closing}
							</div>
							<div className="contact-closing-meta">
								{contact.response}
							</div>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
